import { useEffect, useState } from "react";
import useWallet from "./useWallet";

export enum AccountType {
  CONTRACT = "contract",
  EOA = "eoa",
}

export default function useAccountType() {
  const { active, account, signer } = useWallet();
  const [contractType, setContractType] = useState<AccountType | null>(null);

  useEffect(() => {
    if (!active || !account) {
      setContractType(null);
      return;
    }
    (async function () {
      const code = await signer?.provider?.getCode(account);
      setContractType(code === "0x" ? AccountType.EOA : AccountType.CONTRACT);
    })();
  // signer intentionally omitted: it's unstable across renders (new object each time)
  // and is always replaced when account/active changes, so those deps are sufficient.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, active]);

  return contractType;
}
